{
  "hero": {
    "title": "הפוך את קטלוג המוצרים שלך ל",
    "subtitle": "יועצי קניות מבוססי בינה מלאכותית",
    "description": "פרוס כוח מכירות שיחתי שמוכר — לא רק מצ'וטט. באתר שלך, ברשתות חברתיות, בוואטסאפ ובצ'אטGPT.",
    "createAssistant": "צור עוזר בינה מלאכותית",
    "bookDemo": "הזמן הדגמה"
  },
  "nav": {
    "solutions": "פתרונות",
    "products": "מוצרים",
    "pricing": "תמחור",
    "caseStudies": "מקרי בוחן",
    "blog": "בלוג",
    "contact": "צור קשר",
    "shoppingExpert": "מומחה קניות",
    "gptStore": "חנות GPT"
  },
  "chat": {
    "greeting": "שלום! אני עוזר הקניות המבוסס בינה מלאכותית שלך. נסה לשאול אותי על מוצרים כמו טלוויזיות, מחשבים ניידים או מכונות קפה. איך אוכל לעזור לך היום?",
    "placeholder": "הקלד את ההודעה שלך כאן...",
    "contact": {
      "heading": "אנא שתף את פרטי הקשר שלך"
    }
  },
  "sections": {
    "partners": {
      "title": "מהימן על ידי פלטפורמות מובילות"
    },
    "gptPromo": {
      "title": "השק את המותג שלך בחנות ה-GPT",
      "description": "צור עוזר קניות GPT מותאם אישית שמציג את המוצרים שלך והופך גולשים לקונים."
    },
    "solutions": {
      "title": "פתרונות לתעשייה",
      "subtitle": "יועצי קניות מבוססי בינה מלאכותית מותאמים לתעשייה שלך",
      "electronics": {
        "title": "אלקטרוניקה וטכנולוגיה",
        "description": "עזור ללקוחות לנווט במפרטים טכניים מורכבים ולמצוא את המכשיר המושלם.",
        "items": [
          "השוואות מוצרים חכמות",
          "התאמת מפרטים טכניים",
          "בדיקת תאימות",
          "המלצות ביצועים"
        ]
      },
      "fashion": {
        "title": "אופנה וביגוד",
        "description": "ספק ייעוץ סטיילינג מותאם אישית והמלצות מידה.",
        "items": [
          "התאמת סגנון והמלצות",
          "הדרכת מידה והתאמה",
          "ייעוץ מגמות עונתיות",
          "תיאום תלבושות"
        ]
      },
      "home": {
        "title": "בית וגן",
        "description": "הדרך לקוחות דרך החלטות שיפור הבית ועיצוב.",
        "items": [
          "ייעוץ עיצוב חדרים",
          "המלצות מכשירים",
          "ייעוץ אופטימיזציית חלל",
          "הדרכת תחזוקה"
        ]
      },
      "agency": {
        "title": "סוכנויות ושותפים",
        "description": "פתרונות לבנים עבור סוכנויות המשרתות לקוחות קמעונאיים מרובים.",
        "items": [
          "ניהול מרובה לקוחות",
          "אפשרויות מיתוג מותאמות",
          "אנליטיקה ודיווח",
          "תמיכת שותף סוכנות"
        ]
      }
    },
    "platforms": {
      "title": "פלטפורמה נתמכת"
    },
    "valueProps": {
      "title": "למה לבחור ב-Shopilots?",
      "subtitle": "שנה את חווית הקמעונאות שלך עם בינה מלאכותית שבאמת מוכרת",
      "conversion": {
        "title": "הגדל המרות",
        "description": "הפוך גולשים לקונים עם המלצות מוצר מותאמות אישית וחוויות קניה מודרכות.",
        "metric": "שיעור המרה"
      },
      "aov": {
        "title": "הגדל ערך הזמנה ממוצע",
        "description": "הצעות מכירה נוספות וחוצות מוצרים חכמות שמרגישות טבעיות ומועילות ללקוחות.",
        "metric": "ערך הזמנה ממוצע"
      },
      "returns": {
        "title": "הפחת החזרות",
        "description": "התאמת מוצר טובה יותר פירושה שלקוחות מקבלים בדיוק את מה שהם צריכים בפעם הראשונה.",
        "metric": "שיעור החזרות"
      },
      "advantage": {
        "title": "היתרון של Shopilots",
        "description": "בניגוד לצ'טבוטים גנריים, הבינה המלאכותית שלנו מבינה את המוצרים שלך ומדברת בקול המותג שלך.",
        "features": {
          "catalog": "אינטגרציית קטלוג בזמן אמת",
          "sales": "שיחות ממוקדות מכירות",
          "channels": "פריסה רב-ערוצית",
          "analytics": "אנליטיקה מונעת הכנסות"
        }
      },
      "testimonial": {
        "title": "הצלחת לקוחות",
        "quote": "Shopilots שינתה את המכירות המקוונות שלנו. לקוחות מוצאים מוצרים מהר יותר וקונים בביטחון רב יותר.",
        "name": "שרה ג'ונסון",
        "position": "מנהלת מסחר אלקטרוני"
      }
    }
  },
  "micro": {
    "demoMode": "מצב הדגמה"
  },
  "forms": {
    "name": "שם",
    "email": "אימייל",
    "company": "חברה",
    "phone": "טלפון",
    "optional": "אופציונלי",
    "thankYou": "תודה רבה!"
  },
  "buttons": {
    "sending": "שולח...",
    "submit": "שלח",
    "launchAssistant": "השק את עוזר הבינה המלאכותית שלך",
    "callUs": "התקשר אלינו",
    "learnMore": "למד עוד",
    "getStarted": "התחל",
    "findSolution": "מצא את הפתרון שלך"
  },
  "footer": {
    "description": "יועצי קניות מבוססי בינה מלאכותית שמוכרים — לא רק מצ'וטטים. פרוס באתר שלך, ברשתות חברתיות, בוואטסאפ ובצ'אטGPT.",
    "solutions": "פתרונות",
    "resources": "משאבים",
    "contactUs": "צור קשר",
    "copyright": "כל הזכויות שמורות.",
    "links": {
      "privacyPolicy": "מדיניות פרטיות",
      "termsOfService": "תנאי שימוש",
      "sitemap": "מפת אתר"
    }
  }
}